<template>
  <div class="per">
    <Header class="get-header" zai="true"  v-if="!edit" titles="完善个人信息"></Header>
    <Header class="get-header" v-else titles="编辑个人信息"></Header>
    <div class="per-body">
      <div class="per-eve">
        <div class="per-name">
          <img src="@/assets/image/user-nick.png" alt="">
          昵称
          <span class="per-red" v-if="!edit">*</span>
        </div>
        <div class="complete">
          <input type="text" @keyup="checkUser" class="per-int" v-model="sis.username" value="">
        </div>
      </div>
      <div class="per-eve">
        <div class="per-name">
          <img src="@/assets/image/user-degree.png" alt="">
          学历<span class="per-red" v-if="!edit">*</span>
        </div>
        <div class="complete" @click="showDrgee= true">
          <input type="text" v-model="sis.academic" class="per-int" value="">
        </div>
      </div>
      <!-- <div class="per-eve">
        <div class="per-name">专业</div>
        <div>
          <input type="text" v-model="sis.profession" class="per-int" value="">
        </div>
      </div> -->
      <div class="per-eve">
        <div class="per-name">
          <img src="@/assets/image/user-email.png" alt="">
          邮箱<span class="per-red" v-if="!edit">*</span>
        </div>
        <div class="complete">
          <input type="text" v-model="sis.email" class="per-int" value="">
        </div>
      </div>
      <div class="per-eve" v-if="!edit">
        <div class="per-name">
          <img src="" alt="">
          性别<span class="per-red" v-if="!edit">*</span>
        </div>
        <RadioGroup class="chos" v-model="sis.sex">
          <Radio class="cho-p" name="男">男</Radio>
          <Radio name="女">女</Radio>
        </RadioGroup>
      </div>
      <div class="per-eve" v-if="tagShow">
        <div class="per-name">
          <img src="@/assets/image/user-tag.png" alt="">
          标签<span class="per-red" v-if="!edit">*</span>
        </div>
        <div class="per-tag">
          <div class="tag-remove" v-for="(item, index) in sis.tag" :key="index">
            <span>{{item}}</span>
            <span class="tag-close" @click="removeTag(index)">X</span>
          </div>
          <router-link class="tag-add" v-if="!edit" to="/bos/register">选择标签</router-link>
          <router-link class="tag-add" v-else :to="{path:'/bos/register',query: {edit: 1}}">选择标签</router-link>
        </div>
      </div>
      <div class="per-eve" v-if="!edit">
        <div class="per-name"></div>
        <div>
          <van-checkbox v-model="sis.is_receive_sms" >是否接受任务发布短信</van-checkbox>
        </div>
      </div>
    </div>
    <Popup v-model="showDrgee" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="选择学历"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </Popup>
    <div class="per-footer">
      <div class="per-next" @click="gogo()" v-if="!edit">下一步</div>
      <div class="per-next" @click="edits()" v-else>保存</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import { RadioGroup, Radio, Toast, Popup } from 'vant'
import { register, editUser, getUserInfo } from '@/api/api/user.js'
import Cookie from 'js-cookie'

export default {
  components:{
    Header,
    RadioGroup,
    Radio,
    Popup
  },
  data(){
    return {
      tagShow: true,
      columns: ['高中', '专科', '本科', '硕士', '博士'],
      sis: {
        username: '',
        is_receive_sms: true
      },
      www: ['1','2'],
      edit: null,
      oldname: '',
      showDrgee: false
    }
  },
  activated() {
    this.sis.tag = this.$store.state.chotag
    this.sis.mobile = this.$store.state.phone || sessionStorage.getItem('setphone')
    this.$forceUpdate()
  },
  created() {
    this.www = JSON.stringify(this.www)
    this.edit = this.$route.query.edit
    this.sis.uid = sessionStorage.getItem('tuid')
    if(this.edit) {
      this.getUser()
    }
  },
  methods: {
    onConfirm(value) {
      this.sis.academic = value
      this.showDrgee = false
    },
    onCancel() {
      this.showDrgee = false
    },
    checkUser(){
      if (this.sis.username.length > 60) {
        this.sis.username = this.sis.username.substr(0, 60)
        Toast('昵称不能超过60个字符')
      }
    },
    gogo() {
      if (this.sis.academic == '' || !this.sis.academic) return Toast('学历不能为空')
      if (this.sis.username == '' || !this.sis.username) return Toast('昵称不能为空')
      if (this.sis.email == '' || !this.sis.email) return Toast('邮箱不能为空')
      if (!this.sis.sex) return Toast('请选择性别')
      if (!this.sis.tag) return Toast('请选择标签')
      JSON.stringify(this.sis.tag)
      register(this.sis).then(res => {
        if(res.data.httpCode === "200") {
          if(res.data.errorCode == '0') {
            console.log(res)
            Cookie.set('token', res.data.data.token, { expires: 0.05 })
            this.$store.commit('SET_TOKEN', res.data.data.token)

            this.$hideLoading()
            Toast({
              type: 'success',
              message: '登录成功',
              duration: 1000
            })
              setTimeout(() => {
                this.$router.replace({path:'/home'})
              }, 1000);
          } else {
            this.$hideLoading()
            Toast({
              type: 'fail',
              message: res.data.errorMsg,
              duration: 1000
            })
          }
        }
      })
    },
    edits() {
      if (this.sis.username === this.oldname) {
        delete this.sis.username
      }
      
      if (this.sis.academic == '') return Toast('学历不能为空')
      if (this.sis.username == '') return Toast('昵称不能为空')
      if (this.sis.email == '') return Toast('邮箱不能为空')

      // this.sis.tag = JSON.stringify(this.sis.tag)
      editUser(this.sis).then( res => {
        if(res.data.errorCode == 0) {
          Toast({
            type: 'fail',
            message: '保存成功',
            duration: 1000
          })
          Cookie.set('token', res.data.data.token, { expires: 1 })
          this.$store.commit('SET_TOKEN', res.data.data.token)
          setTimeout(() => {
            this.$router.back()
          }, 1200)
        } else {
          Toast({
            type: 'fail',
            message: res.data.errorMsg,
            duration: 1000
          })
        }
      })
    },
    removeTag(i) {
      this.sis.tag.splice(i,1)
      this.$store.commit('SET_TAG', this.sis.tag)
      this.$forceUpdate()
    },
    getUser() {
      getUserInfo().then(res => {
        this.sis.username = res.data.data.username
        this.sis.is_receive_sms = res.data.data.is_receive_sms
        this.oldname = res.data.data.username
        this.sis.academic = res.data.data.academic
        // this.sis.profession = res.data.data.profession
        this.sis.email = res.data.data.email
        this.sis.sex = res.data.data.sex
        this.sis.tag = res.data.data.tag.split(',')
        this.$store.commit('SET_TAG', res.data.data.tag.split(','))
        if(this.sis.tag.indexOf('PAB顾问') !== -1) {
          this.tagShow = false
        }
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss">
.per {
  .get-header {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .per-footer {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 10px;
    z-index: 99;
    background: white;
    height: 76px;
    display: flex;
    justify-content: center;
    .per-next {
      z-index: 100;
      text-align: center;
      line-height: 46px;
      color: white;
      height: 46px;
      width: 60%;
      background: #4464eb;
    }
  }
  .per-body {
    padding: 0 15%;
    padding-top: 59px;
    padding-bottom: 79px;
    .per-eve {
      display: flex;
      align-items: center;
      padding-top: 10px;
      .per-tag {
        width: 78%;
        display:block;
        .tag-remove {
          height: 34px;
          line-height: 34px;
          text-align: center;
          display: inline-block;
          // float: left;
          background: #F2F2F4;
          padding-left: 8px;
          padding-right: 8px;
          margin-right: 8px;
          margin-bottom: 8px;
          .tag-close {
            display: inline-block;
            padding-left: 12px;
            color: #999999;
          }
        }
        .tag-add {
          height: 34px;
          line-height: 34px;
          text-align: center;
          display: inline-block;
          padding: 0 15px;
          color: #4464eb;
          border: 1px dashed #4464eb;
        }
      }

      .chos {
        padding-top: 10px;
        display: flex;
        .cho-p {
          margin-right: 8px;
        }
      }

      .per-name {
        width: 60px;
        padding-top: 15px;
        padding-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        img {
          width: 18px;
          height: 16px;
        }
        .per-red {
          display: inline-block;
          padding-left: 3px;
          color: red;
        }
      }
      .complete {
        flex: 1;
      }
      .per-int {
        padding: 0 8px;
        border-bottom: 1px solid #ccc;
        width: 100%;
        height: 48px;
        font-size: 14px;
        .eveop {
          font-size: 14px;
        }
      }
    }
  }
}
</style>